
import React from 'react';
import { useNavigate } from 'react-router-dom';
import "./carstyle.css"
const Card = ({ title, content, logo,path }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(path); 
  };
  return(
    <div className='card tracking-widest h-[25rem]' onClick={handleClick}>
      <img src={logo} alt='Event Logo ' className='card-logo ' />
      <div className='card-details text-slate-100 flex text-center'>
        <h2 className='text-slate-100'>{title}</h2>
        <p className='text-slate-100'>{content}</p>
        <button className='know-more-btn'>Know More</button>
      </div>
    </div>);
  };
  export default Card;